import React from 'react';
import { Helmet } from 'react-helmet';
import './Subscribe.css';
import { useNavigate } from "react-router-dom";

const Subscribe = () => {

const navigate = useNavigate();


  return (
    <>
      <Helmet>
        <title>Subscribe - Redbox Global</title>
        <meta name="description" content="Subscribe to Redbox Global for unlimited access to global business news and insights" />
      </Helmet>

      <div className="subscribe-page">
        {/* Hero Section */}
        <div className="subscribe-hero">
          <div className="hero-content">
            <h1>Unlock the global benchmark for business news</h1>
            
            <div className="hero-offer">
              <h3>Get Monthly Digital Access</h3>
              <p className="price">
                
                <span className="new-price">$1.99 for your first month</span>
              </p>
              <p className="offer-details">
                Auto-renews for $14.99 monthly after 1 month. Cancel anytime before your plan renews. 
                Tax included if applicable. Price subject to change. Intro offer is for new subscribers only.
              </p>
               
               

              

              <button 
                      className="continue-button"
                   onClick={() => navigate("/subscriptions/checkout")}
                >
                    Continue
               </button>
              
              <div className="payment-methods">
                <span>We accept:</span>
                <div className="payment-icons">
                 
                   <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg" alt="Google Pay" />
                   <img src="https://www.paypalobjects.com/webstatic/icon/pp258.png" alt="PayPal" />
                   <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png" alt="Mastercard" />
                </div> 
              </div>
            </div>
          </div>
          
          <div className="hero-features">
            <div className="feature-item">
              <h4>In-Depth Analysis</h4>
              <p>Expert insights and comprehensive coverage</p>
            </div>
            <div className="feature-item">
              <h4>Live Q+A, and 24/7 BTV</h4>
              <p>Unlimited access to Bloomberg Television</p>
            </div>
            <div className="feature-item">
              <h4>30+ exclusive newsletters</h4>
              <p>Curated content delivered to your inbox</p>
            </div>
          </div>
        </div>

        {/* Other Plan Options */}
        <div className="plan-options">
          <h2 className="section-title">OTHER PLAN OPTIONS</h2>
          <p className="section-subtitle">
            Cancel a plan anytime before its renewal date. Tax included if applicable. Price subject to change.
          </p>

          <div className="plans-grid">
            {/* New Year Sale */}
            <div className="plan-card">
              <h3>New Year Sale: Save 60% with Annual Access</h3>
              <div className="plan-price">$79 your first year</div>
              <p className="plan-details">Auto-renews for $149/year</p>
              <button className="plan-button">Choose Annual Billing</button>
            </div>

            {/* Annual + Print */}
            <div className="plan-card">
              <h3>Annual + Businessweek Print</h3>
              <div className="plan-price">$109 your first year</div>
              <p className="plan-details">
                Auto-renews for $179 annually<br />
                Includes monthly editions of Redbox Global Businessweek Magazine
              </p>
              <button className="plan-button">Choose Annual + Print</button>
            </div>

            {/* Corporate */}
            <div className="plan-card">
              <h3>Corporate Subscriptions</h3>
              <p className="plan-details" >
                Provide your team total access to Redbox Global.com
              </p>
              <button className="plan-button">Learn More</button>
            </div>

            {/* Tech Newsletter */}
            <div className="plan-card">
              <h3>Tech Newsletter Bundle</h3>
              <div className="plan-price">$11.99/month</div>
              <p className="plan-details">
                Includes <strong>Tech in Depth</strong>, <strong>Power On</strong>, <strong>Game On</strong>,{' '}
                <strong>Q&AI</strong>, and <strong>Soundbite</strong> and all articles linked within these newsletters
              </p>
              <button className="plan-button">Choose Tech Newsletter Bundle</button>
            </div>

            {/* Student Plan */}
            <div className="plan-card">
              <h3>Student Plan</h3>
              <div className="plan-price">$9.99/month</div>
              <p className="plan-details">
                Auto-renews at $14.99/month after graduation<br />
                To get a quote for your academic institution,{' '}
                <a href="/support">click here</a>
              </p>
              <button className="plan-button">Choose Student</button>
            </div>

            {/* Gift Subscription */}
            <div className="plan-card">
              <h3>Gift Subscription</h3>
              <p className="plan-details" >
                Gift a year of unlimited insights<br />
                (does not auto-renew)
              </p>
              <button className="plan-button">Choose Gift Subscription</button>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <h2>Frequently Asked Questions</h2>
          
          <div className="faq-item">
            <h4>What's included in my subscription?</h4>
            <p>
              Unlimited access to Redbox Global.com and our mobile apps, including breaking news, 
              in-depth analysis, exclusive newsletters, and Bloomberg Television live stream.
            </p>
          </div>
          
          <div className="faq-item">
            <h4>Can I cancel anytime?</h4>
            <p>
              Yes, you can cancel your subscription at any time before your renewal date. 
              No refunds for partial months.
            </p>
          </div>
          
          <div className="faq-item">
            <h4>What payment methods do you accept?</h4>
            <p>
              We accept all major credit cards, PayPal, Google Pay, and other digital payment methods.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Subscribe;
